var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.8535,
    y: 9.85278,
    width: 57.9492,
    height: 64.0441,
    rx: 6.5,
    fill: "white",
    stroke: "url(#paint0_linear_604_32397)",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.4484,
    height: 40.923,
    rx: 2,
    transform: "matrix(1 0 0 -1 51.2715 68.4309)",
    fill: "url(#paint1_linear_604_32397)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 10.4484,
    height: 27.8625,
    rx: 2,
    transform: "matrix(1 0 0 -1 35.6074 68.4309)",
    fill: "url(#paint2_linear_604_32397)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.4484,
    height: 18.2847,
    rx: 2,
    transform: "matrix(1 0 0 -1 19.9336 68.4309)",
    fill: "url(#paint3_linear_604_32397)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0135 22.1218L56.1435 18.9329C55.9025 18.6651 56.0152 18.238 56.357 18.1241L61.1403 16.5296C61.5442 16.395 61.9208 16.7944 61.7627 17.1897L59.8494 21.973C59.7118 22.3168 59.2612 22.3971 59.0135 22.1218Z",
    fill: "#FF6C22",
    stroke: "#FF6D23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6761 19.6721L54.7991 23.226C54.1252 23.8438 53.0471 23.6422 52.642 22.8227C52.1936 21.9157 50.9513 21.7894 50.3295 22.5876L41.6823 33.6877C40.9798 34.5894 39.6658 34.72 38.7996 33.9742L37.4789 32.8371C36.664 32.1355 35.4401 32.2038 34.7084 32.9919L23.5626 44.995C22.7413 45.8796 21.3294 45.8405 20.5583 44.9117L20.3652 44.6792",
    stroke: "#FF6D23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 6.35352,
    y: 4.35254,
    width: 38.4746,
    height: 75.0442
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_604_32397_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4,
    d: "M40.8281 8.35254H18.3536C13.9353 8.35254 10.3535 11.9343 10.3535 16.3525V67.3966C10.3535 71.8149 13.9353 75.3966 18.3535 75.3966H40.8281V8.35254Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_604_32397_clip_path",
    transform: "translate(-6.35352 -4.35254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8281 8.35254H18.3536C13.9353 8.35254 10.3535 11.9343 10.3535 16.3525V67.3966C10.3535 71.8149 13.9353 75.3966 18.3535 75.3966H40.8281V8.35254Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_604_32397",
    x1: 13.401,
    y1: 8.35278,
    x2: 63.4664,
    y2: 75.3968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995723,
    stopColor: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_604_32397",
    x1: 5.22421,
    y1: 0,
    x2: 5.22421,
    y2: 40.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0341522,
    stopColor: "#FFB104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279731,
    stopColor: "#FD9123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_604_32397",
    x1: 5.22421,
    y1: 0,
    x2: 5.22421,
    y2: 27.8625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0341522,
    stopColor: "#FFB104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279731,
    stopColor: "#FD9123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_604_32397",
    x1: 5.22421,
    y1: 0,
    x2: 5.22421,
    y2: 18.2847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0341522,
    stopColor: "#FFB104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279731,
    stopColor: "#FD9123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon);
export default __webpack_public_path__ + "static/media/stats-icon.82b3bd7bd200d5ee24028a70b34246bb.svg";
export { ForwardRef as ReactComponent };